
    <label class="day-toggler" [class.selected]="value">
      <input class="day-toggler__checkbox" type="checkbox" [(ngModel)]="value" />
      <span class="day-toggler__weekday">{{date | shortDate}}</span>
      <span class="day-toggler__day">{{date | date:'d'}}</span>
      <svg class="day-toggler__ico ico">
          <use xlink:href="assets/symbol/svg/sprite.css.svg#icon_check"></use>
      </svg>
    </label>
  